import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

const regex = /(^.*)\/\(.*\)$/;

/**
 * CanActivate function to strip secondary routes from the url
 * @param route
 * @param state
 * @returns
 */
export const stripSecondaryRoutesOnActivateGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const router = inject(Router);

	if (regex.test(state.url)) {
		const newUrl = router.parseUrl(state.url.replace(regex, '$1'));
		return newUrl;
	}
	return true;
};

/**
 * Higher-order function to return a function that strips a specific secondary route from the url.
 * @param key
 * @returns
 */
export const stripSpecificSecondaryRouteOnActivateGuard = (key: string) => {
	return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
		const router = inject(Router);

		const regex = new RegExp(`${key}:.*//`);
		if (regex.test(state.url)) {
			const newUrl = router.parseUrl(state.url.replace(regex, ''));
			return newUrl;
		}
		return true;
	};
};
